"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSeflStrategy = createSeflStrategy;
const constants_1 = require("../constants");
const validationHelpers_1 = require("../common/validationHelpers");
function createSeflStrategy(options) {
    const { enableCheckDigit } = options;
    const getCheckDigit = (proNumber) => {
        const pro8 = proNumber.substring(0, 8);
        let sum = 0;
        for (let i = 0; i < 8; i++) {
            const digit = parseInt(pro8[i], 10);
            sum += digit * (9 - i);
        }
        const checkDigit = 11 - (sum % 11);
        return checkDigit >= 10 ? checkDigit - 10 : checkDigit;
    };
    const getProNumberWithCheckDigit = ({ proNumber, }) => {
        if (proNumber === "0") {
            return "";
        }
        return proNumber || "";
    };
    const validateProNumber = (validationInput) => {
        const { proNumber } = validationInput;
        const actualLength = proNumber.length;
        // Check if pro starts with '0' (invalid for SEFL)
        if (proNumber.startsWith("0")) {
            return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.INVALID_PRO_NUMBER);
        }
        // Check if length is 7 or 9 (valid lengths for SEFL)
        if (actualLength !== 7 && actualLength !== 9) {
            return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.INVALID_PRO_NUMBER);
        }
        // Validate check digit for 9-digit numbers if enabled
        if (actualLength === 9 && enableCheckDigit) {
            const enteredCheckDigit = parseInt(proNumber[8], 10);
            const expectedCheckDigit = getCheckDigit(proNumber);
            if (enteredCheckDigit !== expectedCheckDigit) {
                return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.INVALID_CHECK_DIGIT);
            }
        }
        return null; // Valid
    };
    const isTempProNumber = (proNumber) => {
        return false;
    };
    return {
        getProNumberWithCheckDigit,
        validateProNumber,
        isTempProNumber,
        getCheckDigit,
    };
}
